function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import ReactTooltip from 'react-tooltip';
import { scrollToHash } from 'helpers/urlTools';
import App, { IntlHelmet, LanguageProvider, OfflineOverlay } from 'modules/App';
import messages from '../../messages';
import Sidebar from './Sidebar';
import styles from './PortalLayout.pcss';
var _React_Component;
class PortalLayout extends (_React_Component = React.Component) {
    componentDidMount() {
        if (this.props.isClientInitialized) {
            this.onSetIsInit();
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.isInit !== this.state.isInit && this.state.isInit) {
            scrollToHash(this.props.route, 0, 0, this.mainContentEl);
        }
        if (prevProps.isClientInitialized !== this.props.isClientInitialized && this.props.isClientInitialized) {
            this.onSetIsInit();
        }
    }
    onSetIsInit() {
        this.setState({
            isInit: true
        });
    }
    onClickLayout() {
        this.props.onCloseDropdown();
    }
    onKeyDown(evt) {
        // If ESC
        if (evt.keyCode === 27) {
            this.props.onCloseDropdown();
        }
    }
    renderContent() {
        return /*#__PURE__*/ _jsx("div", {
            id: "mainContent",
            className: styles.content,
            ref: (el)=>{
                this.mainContentEl = el;
            },
            children: this.props.children
        });
    }
    render() {
        if (!this.state.isInit || !this.props.children) return null;
        const titleMessage = this.props.metaTitleMessage ? this.props.metaTitleMessage : _object_spread({}, messages.meta.title);
        const descriptionMessage = this.props.metaDescriptionMessage ? this.props.metaDescriptionMessage : _object_spread({}, messages.meta.description);
        return /*#__PURE__*/ _jsx(LanguageProvider, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.root, 'no-gutters'),
                onClick: ()=>this.onClickLayout(),
                onKeyDown: (evt)=>this.onKeyDown(evt),
                children: [
                    /*#__PURE__*/ _jsx(IntlHelmet, {
                        titleMessage: titleMessage,
                        descriptionMessage: descriptionMessage
                    }),
                    /*#__PURE__*/ _jsx(Sidebar, {}),
                    this.renderContent(),
                    /*#__PURE__*/ _jsx(ReactTooltip, {
                        id: "globalTooltip",
                        place: "right",
                        type: "dark",
                        effect: "solid",
                        className: "tooltip",
                        backgroundColor: "#383B44",
                        multiline: true
                    }),
                    /*#__PURE__*/ _jsx(OfflineOverlay, {})
                ]
            })
        });
    }
    constructor(props){
        super(props);
        this.mainContentEl = null;
        this.state = {
            isInit: false
        };
    }
}
_define_property(PortalLayout, "propTypes", {
    // Explicit props
    children: PropTypes.node,
    metaTitleMessage: PropTypes.object,
    metaDescriptionMessage: PropTypes.object,
    // Implicit props
    route: App.shapes.route,
    isClientInitialized: PropTypes.bool,
    // Implicit action
    onCloseDropdown: PropTypes.func
});
const mapStateToProps = (state)=>({
        route: App.selectors.route(state),
        isClientInitialized: App.selectors.isClientInitialized(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onCloseDropdown: ()=>dispatch(App.actions.closeDropdown())
    });
const ConnectedPortalLayout = connect(mapStateToProps, mapDispatchToProps)(PortalLayout);
export default withStyles(styles)(ConnectedPortalLayout);
